import React, { Fragment } from 'react'
import SiteHeader from '../../../components/SiteHeader';
import Breadcumb from '../../../components/Breadcumb'
import About from '../../../components/About'
import WhyChooseUs from '../../../components/WhyChooseUs'
import Statistics from '../../../components/Statistics'
import CallToAction from '../../../components/CallToAction'
import FooterArea from '../../../components/FooterArea'
import Seo from '../../../components/Seo'
import { breadcrumbSchema } from '../../../seo/config'
// images
import about from '../../../images/about/2.jpg'
import breadcumb from '../../../images/breadcumb/about-practice.jpg'

import './style.scss'

const aboutText = [
    {
        text: `Legal Corridor is a premier law firm based in Delhi, led by the esteemed Adv. Aman Verma. With a commitment to delivering exceptional legal services, we specialize in a diverse range of practice areas to meet the needs of our clients.`
    },
    {
        text: `<br /><strong>Our Mission:</strong> To provide unparalleled legal representation while upholding the highest standards of integrity, professionalism, and client care. We are dedicated to prioritizing our clients' needs and tailoring our services to achieve their goals.<br /><br /><strong>Our Vision:</strong> To be the most trusted name in legal services across India, known for excellence, innovation, and unwavering commitment to justice.`
    }
];

const valuesContent = [
    {
        text: `<strong>Excellence:</strong> Striving for excellence in every case we handle, ensuring thorough preparation and strategic execution.<br /><br /><strong>Integrity:</strong> Maintaining the utmost honesty and transparency in all our dealings.<br /><br /><strong>Client-Centric:</strong> Prioritizing our clients' needs and tailoring our services to achieve their goals.`
    }
];

const breadcumbMenu = [
    { name: 'Home', route: '/' },
    { name: 'About Us' }
]

const AboutPage = () => {
    return (
        <Fragment>
            <Seo
                title="About Us — Delhi Law Firm Led by Adv. Aman Verma"
                description="Learn about Legal Corridor, a premier Delhi law firm led by Adv. Aman Verma, delivering expert litigation and advisory across civil, criminal, corporate, property and family law."
                path="/about"
                schema={[breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'About Us', path: '/about' }])]}
            />
            <SiteHeader />
            <main>
            <Breadcumb
                className="breadcumbArea"
                title="About Us"
                breadcumbMenu={breadcumbMenu}
                background={breadcumb}
            />

            <About
                className="aboutArea aboutAreaStyleTwo"
                title="Welcome to Legal Corridor"
                subTitle="Our Story"
                images={about}
                orderLast="order-last"
                videoId="XxVg_s8xAms"
                pragraphs={aboutText}
            />

            {/* <Statistics />

            <WhyChooseUs />

            <About
                className="aboutArea"
                title="Our Core Values"
                subTitle="What Drives Us"
                images={about}
                pragraphs={valuesContent}
            /> */}

            <CallToAction />
            </main>
            <FooterArea />
        </Fragment>
    )
}
export default AboutPage